(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dso-prelaunch"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.querySelector('[data-dso-launch-invitation]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const popup = root.querySelector('#dso-launch-popup');
    const teaser = root.querySelector('[data-dso-launch-open]');
    const close = root.querySelector('[data-dso-launch-close]');
    const key = 'dso-launch-invitation-v1';
    const read = () => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const write = value => { try { sessionStorage.setItem(key, value); } catch {} };
    if (document.querySelector('[data-dso-launch-success]')) { write('subscribed'); return; }
    if (read() === 'subscribed') return;
    const open = manual => {
      popup.hidden = false;
      teaser.hidden = true;
      teaser.setAttribute('aria-expanded', 'true');
      write('shown');
      if (manual) close.focus();
    };
    const dismiss = () => {
      const hadFocus = popup.contains(document.activeElement);
      popup.hidden = true;
      teaser.hidden = false;
      teaser.setAttribute('aria-expanded', 'false');
      write('dismissed');
      if (hadFocus) teaser.focus();
    };
    teaser.addEventListener('click', () => open(true));
    close.addEventListener('click', dismiss);
    root.addEventListener('keydown', event => { if (event.key === 'Escape' && !popup.hidden) dismiss(); });
    const inline = document.querySelector('#dso-launch-signup');
    inline?.addEventListener('focusin', () => { if (!popup.hidden) dismiss(); });
    window.setTimeout(() => {
      if (!root.isConnected || read() === 'subscribed') return;
      const rect = inline?.getBoundingClientRect();
      const inlineVisible = rect && rect.top < innerHeight && rect.bottom > 0;
      const editing = ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName);
      if (matchMedia('(max-width: 749px)').matches || read() || document.hidden || inlineVisible || editing || document.querySelector('dialog[open]')) {
        teaser.hidden = false;
      } else { open(false); }
    }, 20000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
